import axios from "axios";
import { handleError } from "../handleError";
import { LError } from "../../object";
const state = {};
const getters = {};
const mutations = {};
const actions = {
  // 获取账单列表
  async getBillList({ dispatch }, { pagination, sortStack, search, filter }) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/paymentApi/smaco/bill/master",
        pagination,
        sortStack,
        search,
        filter: filter || {},
        method: "post",
        transDict: {
          plate: "plateNumb"
        }
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  // 获取用户支付记录
  async getUserBillList(
    { dispatch },
    { pagination, sortStack, search, filter }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/paymentApi/smaco/account/pay/list",
        pagination,
        sortStack,
        search,
        filter: [filter, { key: "payMode", value: "balance_normal" }],
        method: "post"
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  // 获取用户充值记录
  async getUserPayList(
    { dispatch },
    { pagination, sortStack, search, filter }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/paymentApi/smaco/account/recharge/list",
        pagination,
        sortStack,
        search,
        filter: [filter],
        method: "post"
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  // 创建订单
  async createOrder({ dispatch }, params) {
    let url = "/paymentApi/smaco/pay/weixin/applet/createOrder";
    try {
      let res = null;
      res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  // 用户余额支付
  async createOrderByLeft({ dispatch }, params) {
    let url = "/paymentApi/smaco/bill/settle";
    try {
      let res = null;
      res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /*二维码扫码支付*/
  async getPayCode({ dispatch }, params) {
    let url = "/paymentApi/smaco/pay/weixin/scan/createOrder";
    try {
      let res = null;
      res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 获取用户钱包信息 */
  async getUserInfo(
    { dispatch },
    { pagination, sortStack, search, filter = [] }
  ) {
    let { items, amount } = await dispatch(
      "getDataList",
      {
        url: "/paymentApi/smaco/account/info/list",
        pagination,
        sortStack,
        search,
        filter: [filter],
        method: "post"
      },
      { root: true }
    );
    return {
      items,
      amount
    };
  },
  /* 用户充值 */
  async recharge({ dispatch }, params) {
    let url = "/paymentApi/smaco/account/recharge";
    try {
      let res = null;
      res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /* 缴费模拟测试 */
  async paySimulateTest({ dispatch }, params) {
    let url = "/paymentApi/smaco/bill/passTest";
    try {
      let res = await axios.post(url, params);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  },
  /*根据卡口ID查询账单*/
  async getBillByControllerId({ dispatch }, controllerId) {
    let url = "/paymentApi/smaco/bill/getPlateByGateId?gateId=" + controllerId;
    try {
      let res = await axios.get(url);
      return res;
    } catch (e) {
      if (e instanceof Promise) {
        let err = await e;
        throw handleError(err);
      } else {
        throw handleError(e);
      }
    }
  }
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
